module.exports = __webpack_public_path__ + "img/error.5bc34a8a.svg";